import { Component, OnInit, inject } from '@angular/core';
import { translations } from '../../../../shared/translations/app.translations';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslationState } from '../../../../shared/state/TranslationState';
import { TranslationService } from '../../../../shared/translations/services/translation.service';
import { Store } from '@ngxs/store';
import { StateManagementService } from '../../../../shared/services/state-management.service';
import { UnsavedChangesService } from '../../../../shared/services/unsaved-changes.service';
import { LaoWindowService } from '../../../../shared/services/lao-window.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false
})
export class LogoutComponent implements OnInit {
  isTranslationsLoading$: Observable<boolean>;
  protected translationService = inject(TranslationService);
  public stateManagementService = inject(StateManagementService);
  public store = inject(Store);
  public router = inject(Router);
  public unsavedChangesService = inject(UnsavedChangesService);
  private readonly laoWindowService = inject(LaoWindowService);

  constructor() {}

  ngOnInit(): void {
    this.isTranslationsLoading$ = this.store.select(TranslationState.loading);
  }

  async logout() {
    const component = this.unsavedChangesService.getComponent();
    if (component && typeof component.canDeactivate === 'function') {
      const canLogout = await Promise.resolve(component.canDeactivate());
      if (!canLogout) {
        return;
      }
    }
    localStorage.setItem('logout', 'true');
    this.clearStorageAndResetStates();
    this.laoWindowService.close();
    setTimeout(() => {
      this.router.navigate(['/authlogin']);
    }, 0);
  }

  clearStorageAndResetStates() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('dealerId');
    window.localStorage.removeItem('customer');
    window.localStorage.removeItem('token-expiry');
    window.localStorage.removeItem('roles');
    window.localStorage.removeItem('firstName');
    window.localStorage.removeItem('lastName');
    this.stateManagementService.resetAllStates();
  }

  protected translations = translations;
}
